import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Tabs } from "antd";
import { useTranslation } from "react-i18next";
import ArcticIconFont from "@/icon";
import styles from "./index.module.less";
import NavigateForm from "../NavigateForm";
import NavigatePanel from "../NavigatePanel";
import ImageryExtractionForm from "../ImageryExtractionForm";
import ImageryExtractionPanel from "../ImageryExtractionPanel";

function ComputeTabs() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const changeMode = useCallback(
    (mode) => {
      dispatch.panel.updateMode(mode);
    },
    [dispatch]
  );
  return (
    <div className={styles.computeTabsPanel}>
      <Tabs defaultActiveKey="planning" onChange={changeMode}>
        <Tabs.TabPane
          tab={
            <div className="tab-title">
              <ArcticIconFont type="icon-calculate" />
              {t("routeCompute")}
            </div>
          }
          key="planning"
        >
          <NavigateForm />
          <NavigatePanel />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab={
            <div className="tab-title">
              <ArcticIconFont type="icon-extract" />
              {t("imageExtract")}
            </div>
          }
          key="detection"
        >
          <ImageryExtractionForm />
          <ImageryExtractionPanel />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}

export default ComputeTabs;
